// Official AeroMax Energy brand logo
// `size` controls the rendered HEIGHT in px (width auto-scales).
// `dark` swaps in the dark-mode variant (navy elements recoloured white)
// so the logo sits transparently on dark navy backgrounds.
export default function Logo({ size = 44, dark = false }) {
  const src = dark ? "/aeromax-logo-dark.png" : "/aeromax-logo.png";
  return (
    <span className="inline-flex items-center">
      <img
        src={src}
        alt="AeroMax Energy — Zero Carbon Homes"
        style={{ height: size }}
        className="w-auto block select-none"
        draggable="false"
      />
    </span>
  );
}
